namespace TabAurous.OMS {
    export interface ProductPartyDetailsRow {
        DetailId?: number;
        ProductId?: number;
        SKU?: string;
        PartyId?: number;
        PartyCode?: string;
        LedgerName?: string;
    }

    export namespace ProductPartyDetailsRow {
        export const idProperty = 'DetailId';
        export const localTextPrefix = 'OMS.ProductPartyDetails';
        export const deletePermission = 'Products:Edit';
        export const insertPermission = 'Products:Edit';
        export const readPermission = 'Products:View';
        export const updatePermission = 'Products:Edit';

        export declare const enum Fields {
            DetailId = "DetailId",
            ProductId = "ProductId",
            SKU = "SKU",
            PartyId = "PartyId",
            PartyCode = "PartyCode",
            LedgerName = "LedgerName"
        }
    }
}
